import mainMenu from 'components/mainMenu'
import $ from 'jquery'

$(document).ready(() =>
{
  $('#main-menu-button button').on('click.'+ module.id, () =>
  {
    mainMenu.open()
  })
})



// WEBPACK FOOTER //
// ./vendor/response200/kustantajat/applications/publicFrontend/scripts/components/mainMenuButton.js